/* eslint-disable react/no-unknown-property */
import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import landingBanner from "../../Assets/Images/bannerImage.jpg";
import rightArrow from "../../Assets/Images/rightArrow.svg";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const Banner = ({ loaded, setLoaded }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleStarted = () => {
    // Detect user's operating system
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isAndroid = /Android/.test(userAgent);

    // Redirect to app store based on operating system
    if (isIOS) {
      window.location.href =
        "https://apps.apple.com/us/app/ezy-watermark-photos-lite/id494473910";
    } else if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.whizpool.ezywatermarklite";
    } else {
      history.push("/home");
    }
  };

  return (
    <div className="d-flex flex-column-reverse flex-lg-row justify-content-between w-100 mx-0 ps-2 pb-2 mb-1 mt_138">
      <div
        onLoad={() => setLoaded([...loaded, "landingtext"])}
        className="text-black landing_header w_39 w-xs-100 pe-0 d-flex flex-column justify-content-center"
      >
        <div className="m-0 p-0 my-3 line_height_1_188 landing_banner_Heading productSans text_16">
          {t("lang.ezywatermark")}
        </div>
        <div className="m-0 p-0 productSans line_height_3_435 text_40">
          <div lg={11} className="p-0">
            {t("LandingBannerDescription1")}
            <span className="productSansBold landing_banner_Heading">
              {t("Watermark")}
            </span>
            {t("LandingBannerDescription2")}
            {/* <span className="productSansBold landing_banner_Heading">{t("Photos")}</span> */}
          </div>
        </div>
        <div
          onLoad={() => setLoaded([...loaded, "landingImage"])}
          className="m-0 my-3 p-0 productSansLight line_height_1_688 text_18"
        >
          <div lg={12} className="p-0">
            {t("LandingBannerSubtext")}
          </div>
        </div>
        <div>
          <div md={6}>
            <button
              onClick={handleStarted}
              className={`CamptonMedium text_14 m-0 mt-2 border-0 px-4 py-2 donebutton rounded-pill
                            d-flex justify-content-center align-items-center`}
            >
              {t("GetStarted")}{" "}
              <img
                className="ms-2  p-2 ps-1 pe-0"
                src={rightArrow}
                alt="Right Arrow"
              />
            </button>
          </div>
        </div>
      </div>
      {loaded.length >= 1 && (
        <div
          onLoad={() => setLoaded([...loaded, "landingImage"])}
          className="d-flex  flex-column align-items-end justify-content-center mx-0 px-0"
        >
          <img
            className="landing_banner  m_e_2"
            src={landingBanner}
            alt="Landing Banner"
          />
        </div>
      )}
    </div>
  );
};

export default Banner;
